module.exports = __webpack_public_path__ + "img/track.45c412b7.png";